var _style, _g, _path, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#9DC53D;}\n\t.st2{fill:#662114;}\n\t.st3{fill:#004137;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.32,74.41c-7.62,0-7.62,2.54-15.24,2.54c-7.62,0-7.62-2.54-15.24-2.54c-10.16,0-22.86,5.08-22.86,22.86 c0,27.94,15.24,50.8,25.4,50.8c7.62,0,7.62-2.54,12.7-2.54c5.08,0,5.08,2.54,12.7,2.54c10.16,0,25.4-22.86,25.4-50.8 C143.18,79.49,130.48,74.41,120.32,74.41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.08,82.03c-1.4,0-2.54-1.14-2.54-2.54l0,0c0-8.74,3.05-16.8,8.37-22.12c0.99-0.99,2.6-0.99,3.59,0 c0.99,0.99,0.99,2.6,0,3.59c-4.37,4.37-6.88,11.12-6.88,18.52C107.62,80.9,106.48,82.03,105.08,82.03L105.08,82.03"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111,78.45c14.53,15.74,30.31-7.15,30.31-7.15C118.25,60.48,111,78.45,111,78.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.55,70.42c-0.26-0.95-0.92-1.75-1.82-2.17c-8.77-4.12-16.57-4.89-23.17-2.29 c-8.41,3.3-11.56,10.91-11.69,11.23c-0.49,1.21-0.23,2.58,0.65,3.54c0.34,0.37,0.69,0.72,1.03,1.06 c4.25,4.13,9.02,5.98,14.17,5.47c11.3-1.11,19.98-13.52,20.35-14.05C144.64,72.4,144.81,71.38,144.55,70.42z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.f051f83217422828ea74e49463ce4883.svg";
export { ForwardRef as ReactComponent };